import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../common/Header';
import { branch } from 'baobab-react/higher-order';
import FaqCategories from './FaqCategories';
import LostKeyComboCallouts from './lostKeyCombo/LostKeyComboCallouts';
import SupportNav from './SupportNav';
import Link from '../common/TrackedLink';
import ButtonLink from '../common/TrackedButtonLink';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';

class Support extends Component {
	render() {
		const faqCategories = this.props.categories.map(
			(category,index) => <FaqCategories category={ category } key={ index } />
		);
		
		return (
			<div className="support">
				<Helmet>
					<title>Customer Support | SentrySafe</title>
					<meta name="description" content="SentrySafe is committed to supporting your needs throughout the lifetime of your safe. View our FAQs, order a key replacement, find your product manual and more." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Customer Support"
					description="Look here for answers to common support questions, access to owner manuals and other product resources."
				/>

				<section className="section section-support-lost-key-combo">
					<header className="section-header row">
						<div className="col">
							<h2>Lost Your Key or Combination?</h2>
							<p>Select your country below to view possible retrieval methods.</p>
						</div>
					</header>
					<LostKeyComboCallouts />
				</section>

				<section className="section section-support-find-model-serial-number">
					<header className="section-header row">
						<div className="col">
							<h2>Find Your Model or Serial Number</h2>
							<p>In order to best serve your support needs, you will first need to find your model or serial number.</p>
						</div>
					</header>
					<div className="section-content row">
						<div className="col">
							<ButtonLink
								className="btn-primary"
								to="/support/find-your-model-or-serial-number"
							>
								Locate model/serial number
							</ButtonLink>
						</div>
					</div>
				</section>

				<section className="section section-support-faqs">
					<header className="section-header row">
						<div className="col">
							<h2>Frequently Asked Questions</h2>
							<p>
								To browse through the knowledge base, click the appropriate category
								link below or view all <Link to="support/faqs/">FAQs</Link>.
							</p>
						</div>
					</header>
					<div className="section-content row">
						<div className="col">
							<ul>
								{ faqCategories }
							</ul>
						</div>
					</div>
				</section>

				<section className="section section-support-callouts">
					<ul className="section-content row">
						<li className="col sm-4">
							<h3>Product Manuals</h3>
							<div className="icon">
								<img
									src={ require('../../resources/img/icons/product-manual-icon.png') }
									alt="Product Manuals"
								/>
							</div>
							<p>Download the latest owner&rsquo;s manual for your product.</p>
							<Link
								className="arrow-link"
								to="/support/product-manuals"
							>
								Find Your Product Manual
							</Link>
						</li>
						<li className="col sm-4">
							<h3>Contact Us</h3>
							<div className="icon">
								<img
									src={ require('../../resources/img/icons/contact-us-icon.png') }
									alt="Contact Us"
								/>
							</div>
							<p>We are dedicated to providing our customers with timely and exceptional service.</p>
							<Link
								className="arrow-link"
								to="/support/contact-us"
							>
								Contact Us
							</Link>
						</li>
						<li className="col sm-4">
							<h3>Videos</h3>
							<div className="icon">
								<img
									src={ require('../../resources/img/icons/video-icon.png') }
									alt="Videos"
								/>
							</div>
							<p>Guides to safe setup, troubleshooting, and other support needs.</p>
							<Link
								className="arrow-link"
								to="/support/videos"
							>
								View Videos
							</Link>
						</li>
					</ul>
				</section>
			</div>
		);
	}
};

export default branch({
	categories: ['category', 'categories']
}, Support);


// WEBPACK FOOTER //
// ./src/pages/support/Index.js